import { generateMutationsFor } from '@/store/tools'

let mutations = [
  'REFRESH',
  'ADD',
  'DELETE',
  'UPDATE',
  'MOVE_UP',
  'SELECT'
]

export default generateMutationsFor(mutations)
